import type { Lang } from './types';

/**
 * Kalite notları motorlarda Türkçe üretilir. İngilizce arayüzde bu notları
 * desen eşlemesiyle çeviririz; tanınmayan notlar olduğu gibi kalır.
 */
export function qualityNote(note: string, lang: Lang): string {
	if (lang !== 'en') return note;

	let m = /^(\d+)\/(\d+) sayfada metin katmanı yok/i.exec(note);
	if (m) return `No text layer on ${m[1]}/${m[2]} pages (possibly a scanned PDF; OCR required).`;

	m = /^(\d+) sayfada metin katmanı bulunamadı\./i.exec(note);
	if (m) return `No text layer on ${m[1]} page(s). Scanned pages are excluded from the analysis.`;

	m = /^(\d+) sayfada metin katmanı bulunamadı/i.exec(note);
	if (m) return `No text layer was found on ${m[1]} page(s).`;

	if (/^Sayfa başına ortalama karakter sayısı düşük/i.test(note))
		return 'The average character count per page is low; the text may be incompletely extracted.';

	m = /^Metnin %([\d.,]+)'i tanınmayan glif/i.exec(note);
	if (m)
		return `${m[1]}% of the text contains unrecognized glyphs; this may be a font or encoding problem.`;

	m = /^(\d+) istatistik ifadesinde operatör kaybı/i.exec(note);
	if (m)
		return `${m[1]} statistical expression(s) may have lost an operator (e.g. "p , .05").`;

	if (/^Metinde kopuk tek karakterler yoğun/i.test(note))
		return 'Many isolated single characters were found; column or ligature extraction may be unreliable.';

	if (/^Belge çok kısa/i.test(note))
		return 'The document is very short; analysis reliability is limited.';

	if (/^DOCX içinde metin bulunamadı/i.test(note))
		return 'No text was found inside the DOCX; the document may contain only images.';

	if (/^\\begin\{document\} bulunamadı/i.test(note))
		return 'No \\begin{document} was found; the whole file was treated as body text.';

	if (/^Kaynakça ortamı/i.test(note))
		return 'No bibliography environment was found; citation checking will be limited.';

	return note;
}
